<template>
  <header
    class="sticky-header day-view-header"
    :class="{
      'split-header': split,
      'h-100': !(
        Object.keys(searchResults).length === 0 &&
        searchResults.constructor === Object
      )
    }"
  >
    <!-- Search Bar -->
    <transition name="drop">
      <search-bar v-if="displaySearch" :hide-search="hideSearch" />
    </transition>
    <!-- /Search bar -->
    <header-top-vue />
    <!-- Main header -->
    <div class="calc-continer bd-bottom">
      <!--Left Icons-->
      <div class="left-icon-container header-icon icons-left">
        <div class="float-left home-split first">
          <router-link to="/chat_dashboard" class="d-block">
            <object
              class="search-icon chat"
              :data="chatIcon"
              type="image/svg+xml"
            ></object>
          </router-link>
        </div>
        <div class="float-left home-split first" @click="redirectToUnreadEmailsPage">
          <span class="email-notification-count" v-if="unreadMailCountOnOtherPage > 0" >{{unreadMailCountOnOtherPage}}</span>
          <router-link to="" class="d-block">
            <object
              class="search-icon chat icon-mailbox "
              :data="emailIcon"
              type="image/png"
            ></object>
          </router-link>
        </div>
        <!-- <div
          v-if="userRole !== 22 && userRole !== 25"
          class="float-left call-icon"
        >
          <router-link to="/phone" class="d-block">
            <img :src="phoneIcon" />
          </router-link>
        </div> -->
      </div>
      <!--Title Bar-->

      <div class="year-wrapper">
        <span>
          <router-link :to="'/year/' + year">{{ year }}</router-link>
        </span>
      </div>
      <!--Rigth icons-->
      <div class="float-right header-icon-contain monthly-view-contain">
        <!-- Split icon -->
        <split-icon :click="toggleSplit" />

        <!-- Search box -->
        <div class="float-left">
          <a
            href="#"
            class="search-box-open d-block"
            @click.prevent="showSearch"
          >
            <object
              class="search-icon"
              :data="searchSvg"
              type="image/svg+xml"
            ></object>
          </a>
        </div>
        <!-- Add new icon -->
        <add-icon-vue />
      </div>
    </div>
    <!-- Monthly swiper -->
    <transition name="fade">
      <monthly-swiper
        v-if="split"
        :current-month="weekMonth + 1"
        :current-year="weekYear"
      />
    </transition>
    <div class="day-view-table-wrapper">
      <p class="monthly-label">{{ split ? "Monthly" : "Weekly" }}</p>
      <div class="small-month-header">
        <a class="text-uppercase" href="#" @click.prevent="goToMonthly">{{
          months[weekMonth]
        }}</a>
      </div>
      <!-- Swiper -->
      <transition name="fade">
        <swiper
          v-if="!split"
          :current-date="week"
          :current-month="weekMonth"
          :current-year="weekYear"
        />
      </transition>
      <!-- /Swiper -->
      <div class="selected-date-container" :class="{ 'split-date': split }">
        {{ day }}, {{ month }}
        <span id="clicked-date">{{ date + "," }}</span>
        {{ year }}
      </div>
    </div>

    <!-- /Main header -->
  </header>
</template>

<script>
import SwiperVue from "./Swiper.vue";
import MonthlySwiper from "./MonthlySwiper.vue";
import SearchbarVue from "../common/Searchbar.vue";
import AddIconVue from "../common/AddIcon.vue";
import HeaderTopVue from "../../common/HeaderTop.vue";
import SplitIcon from "../common/SplitIcon.vue";
import { permissionMixin } from "@/mixins/permissionMixin";
import { mapGetters, mapMutations } from "vuex";
import { monthAndWeekMixin } from "../../../mixins/monthAndWeekMixin.js";

export default {
  mixins: [monthAndWeekMixin, permissionMixin],
  data() {
    return {
      displaySearch: false,
      chatIcon: require("../../../assets/svg/chat-bg-fill.svg"),
      phoneIcon: require("../../../assets/img/phone_26x26.png"),
      emailIcon: require("../../../assets/img/m_email.png")
    };
  },
  methods: {
    ...mapMutations({
      toggleSplit: "toggleShowSplitScreenMonthly",
      setWeek: "setWeek",
      setWeekMonth: "setWeekMonth",
      setWeekYear: "setWeekYear",
      setYear: "setYear",
      setMonth: "setMonth"
    }),
    ...mapMutations("portalemail", {
      resetStateForOtherUser: "resetStateForOtherUser",
      setSelectedUserId: "setSelectedUserId"
    }),
    showSearch() {
      this.displaySearch = true;
    },
    hideSearch() {
      this.displaySearch = false;
    },
    goToMonthly() {
      this.setYear(this.weekYear);
      this.setMonth(this.weekMonth);
      this.$router.push("/monthly");
    },
    redirectToUnreadEmailsPage() {
      if((this.subscriberId === 0) && (this.selectedUserId > 0)) {
        this.resetStateForOtherUser();
        this.setSelectedUserId(0);
      }
      this.$router.push("/emails/unread");
    }
  },
  computed: {
    ...mapGetters({
      date: "getSelectedDayOfMonth",
      week: "getSelectedWeek",
      weekYear: "getWeekYear",
      weekMonth: "getWeekMonth",
      year: "getSelectedYear",
      monthNumber: "getSelectedMonth",
      split: "getShowSplitScreenMonthly",
      userRole: "getUserRole",
      showResultsNow: "getShowResultsNow",
      searchResults: "getSearchResults"
    }),
    ...mapGetters("portalemail", {
      unreadMailCountOnOtherPage: "getUnreadMailCountOnOtherPage",
      subscriberId: "getSubscriberId",
      selectedUserId: "getSelectedUserId"
    }),
    logo() {
      return require("../../../assets/img/logoRightNew.png");
    },
    plusSvg() {
      return require("../../../assets/svg/plus-icon.svg");
    },
    searchSvg() {
      return require("../../../assets/svg/search-icon.svg");
    },
    backSvg() {
      return require("../../../assets/svg/back.svg");
    },
    day() {
      return this.days[
        new Date(this.year, this.monthNumber, this.date).getDay()
      ];
    },
    month() {
      return this.capitalizeFirstLetter(this.months[this.monthNumber]);
    }
  },
  components: {
    swiper: SwiperVue,
    searchBar: SearchbarVue,
    AddIconVue,
    HeaderTopVue,
    SplitIcon,
    MonthlySwiper
  },
  created() {
    setTimeout(() => {
      if (
        this.showResultsNow &&
        !(
          Object.keys(this.searchResults).length === 0 &&
          this.searchResults.constructor === Object
        )
      ) {
        this.displaySearch = true;
      }
    });
  }
};
</script>

<style scoped>
div.horizontal-line {
  border-top: 1px outset lightgray;
  position: absolute;
  top: 42px;
  right: 0vw;
  width: 100vw;
}

.split-header {
  height: 440px !important;
}
header.h-100 {
  height: calc(100% - 42px) !important;
}
.split-date {
  transition: all 0.4s ease-in-out;
  font-size: 14px;
  font-weight: bold;
}

.increase-z {
  position: relative;
  z-index: 99;
}

.year-wrapper {
  cursor: pointer;
  max-width: 200px;
  margin: 0 auto;
  font-size: 28px;
  font-weight: 700;
  color: #d26d13;
  text-align: center;
}

.year-wrapper a {
  cursor: pointer;
}

.year-wrapper span {
  position: relative;
  cursor: pointer;
  z-index: 9;
}
.monthly-label {
  position: fixed;
  top: 110px;
  left: 10px;
  font-size: 12px;
  color: #79797a;
}
.small-month-header {
  position: fixed;
  z-index: 7;
  top: 110px;
  right: 24px;
  background-color: #f8f8f8;
  text-transform: capitalize;
  font-weight: bold;
}
.left-icon-container {
  position: absolute;
  top: 6px;
  z-index: 9999;
}
.icon-mailbox{
  width:26px;
  top:0;
}
.email-notification-count{
  font-size:11px;
  text-align:center;
  position:absolute;
  top:2px;
  right:-4px;
  display:flex;
  justify-content: center;
  align-items: center;
  color:#d26d13;
}
</style>
